// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SB1yUJJQwMwjzDFDs72b{border:1px solid var(--border-neutral-default);border-radius:16px;width:500px;padding:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `SB1yUJJQwMwjzDFDs72b`
};
export default ___CSS_LOADER_EXPORT___;
